import * as r from "react";
import e from "../lib/IconBase.es.js";
import m from "../defs/ChartBar.es.js";
const a = r.forwardRef((o, t) => /* @__PURE__ */ r.createElement(e, { ref: t, ...o, weights: m }));
a.displayName = "ChartBarIcon";
const n = a;
export {
  n as ChartBar,
  a as ChartBarIcon
};
